export abstract class NoraStateManager {
  cleanup(): void {
    // Default implementation does nothing.
  }
}
